import { render, staticRenderFns } from "./UsersDashboard.vue?vue&type=template&id=13e392cf&"
import script from "./UsersDashboard.vue?vue&type=script&lang=js&"
export * from "./UsersDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports